<template>
  <div>
    <div class="main">
      <div class="menu">
        <div class="wrapper">
          <span v-for="(item,index) in permission_routes" :key="index" @click="linkTo(item)">{{ item.meta.title }}</span>
        </div>
      </div>
      <div class="info">
        <div class="wrapper">
          <div class="logo">
            <img style="width: 100%;" src="@/assets/new_logo.png">
          </div>
          <div class="address">地址：广州市荔湾区龙溪大道省实路SSAL校园</div>
          <div class="contact">电话: 18142877220（于老师）18027249510（许老师）18998456341（马老师）&nbsp;&nbsp;&nbsp;
          </div>
          <div class="mail">微信公众号：SSAL国际课程 &nbsp;&nbsp;&nbsp;电子邮箱：info@gdssie.com
          </div>
          <div class="qr-code">
            <img class="img" src="@/assets/QRcode@1x.jpg">
          </div>
          <div class="qr-code-tip">扫码关注我们</div>
        </div>
      </div>
    </div>
    <div class="copy-right">COPYRIGHT©2020&nbsp;&nbsp;广东实验中学A-LEVEL国际部 &nbsp;&nbsp;&nbsp;<span @click="gotoBeian" style="cursor: pointer;">粤ICP备19022943号</span>
    </div>
  </div>
</template>

<script>
import {mapGetters} from 'vuex'

export default {
  name: 'Footer',
  methods: {
    linkTo(path) {
      this.$router.replace({name: path.children[0].name})
    },
    gotoBeian() {
      window.open('https://beian.miit.gov.cn')
    }
  },
  computed: {
    ...mapGetters([
      'permission_routes'
    ])
  }
}
</script>

<style scoped lang="scss">
.main {
  width: 100%;
  height: 360px;
  background: rgba(30, 30, 64, 1);
  display: inline-block;

  .menu {
    width: 100%;
    height: 121px;
    font-size: (16px);
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: rgba(255, 255, 255, 1);
    line-height: 22px;
    display: flex;
    justify-content: center;
    align-items: center;

    .wrapper {
      height: 100%;
      width: 1152px;
      display: flex;
      justify-content: space-around;
      align-items: center;
      border-bottom: solid rgba(47, 52, 65, 1);
    }

    span {
      display: inline;
      cursor: pointer;
      text-align: center;

      &:hover {
        font-weight: 900;
      }
    }
  }

  .info {
    width: 100%;
    height: 234px;
    color: rgba(255, 255, 255, 1);
    display: flex;
    justify-content: center;
    align-items: center;

    .foot-title {
      margin-top: 49px;
      margin-left: -75%;
      font-size: 20px;
    }

    .wrapper {
      height: 234px;
      width: 1152px;
      float: left;
    }

    .logo {
      width: 200px;
      height: 50px;
      margin-top: 35px;
      left: 3px;
    }
  }

  .address {
    float: left;
    margin-top: 31px;
    margin-left: 0;
    width: 800px;
    height: 17px;
    font-size: (12px);
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: rgba(255, 255, 255, 1);
    line-height: 17px;
    text-align: left;
  }

  .contact {
    float: left;
    margin-top: 20px;
    margin-left: 0;
    width: 100%;
    height: 17px;
    font-size: 12px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: rgba(255, 255, 255, 1);
    line-height: 17px;
    text-align: left;
  }
  .mail {
    float: left;
    margin-top: 20px;
    margin-left: 0;
    width: 100%;
    height: 17px;
    font-size: 12px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: rgba(255, 255, 255, 1);
    line-height: 17px;
    text-align: left;
  }

  .qr-code {
    float: right;
    margin-right: 0;
    margin-top: -150px;
    width: 101px;
    height: 101px;

    .img {
      width: 101px;
      height: 101px;
    }
  }

  .qr-code-tip {
    float: right;
    margin-top: -20px;
    margin-right: 0;
    width: 101px;
    height: 17px;
    font-size: 12px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: rgba(255, 255, 255, 1);
    line-height: 17px;
  }
}

.copy-right {
  width: 100%;
  height: 50px;
  background: rgba(191, 156, 107, 1);
  opacity: 0.93;
  margin-top: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 12px;
  /*font-size:  (12px);*/
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(255, 255, 255, 1);
  line-height: 17px;
}
</style>



// WEBPACK FOOTER //
// src/components/Footer.vue